import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchGuestForMerge, mergeGuest } from '../../../sagas/routines';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  saving: false,
  saved: false
};

const fetchGuestMergeHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({ ...state, fetching: false, fetched: true })
});

const mergeGuestHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({ ...state, saving: false, saved: true })
});

export default createReducer(initialState, {
  ...fetchGuestMergeHandler(fetchGuestForMerge),
  ...mergeGuestHandler(mergeGuest)
});
